export default {
    onUpdate: registration => {
        registration.unregister().then(() => {
            alert("New content available");
            window.location.reload()
        })
    }
}
